<template>
  <div
    data-testid="verification-details"
    class="verification-details d-flex flex-column i-p-10"
  >
    <div class="title d-flex flex-row i-gap-6 i-mb-10 i-mr-12">
      <i-featured-icon
        :size="iFeaturedIconSizes.SM"
        :type="
          verification.verified
            ? iFeaturedIconTypes.SUCCESS
            : iFeaturedIconTypes.ERROR
        "
        :symbol="
          verification.verified ? 'small-check-1' : 'small-alert-triangle'
        "
        class="icon"
      ></i-featured-icon>
      <div class="text flex-column align-items-start flex-grow-1">
        <div class="name i-text-button-2 i-text-neutral-120">
          {{ verification.title }}
        </div>
        <div class="subtitle i-text-body-3 i-text-neutral-110">
          {{ verification.subtitle }}
        </div>
      </div>
    </div>
    <div class="verification d-flex flex-row i-px-8 i-py-6 i-radius-xl i-gap-6">
      <i-icon
        :symbol="
          verification.verified ? 'small-solid-check' : 'small-solid-delete'
        "
        :colour="
          verification.verified
            ? palette['light-success-90']
            : palette['light-error-90']
        "
        class="icon i-mt-2"
        :size="16"
      ></i-icon>
      <div class="blocks-list d-flex flex-column i-gap-3">
        <div class="data-block-matched d-flex flex-column">
          <div class="i-text-neutral-110 i-text-body-3">Actual Value</div>
          <div
            :class="{
              'light-error-120': !verification.verified,
              'light-success-120': verification.verified,
            }"
            class="value i-text-button-3"
          >
            {{
              verification.matched === ''
                ? 'Not Verified'
                : verification.matched
            }}
          </div>
        </div>
        <div class="data-block-input d-flex flex-column">
          <div class="i-text-neutral-110 i-text-body-3">Expected Value</div>
          <div class="value i-text-neutral-120 i-text-button-3">
            {{ verification.input || '&nbsp;' }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  iFeaturedIcon,
  iFeaturedIconTypes,
  iFeaturedIconSizes,
  iIcon,
} from '@inscribe/signal';
import palette from '@inscribe/signal/dist/palette';

export default {
  components: { iFeaturedIcon, iIcon },
  props: {
    verification: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      iFeaturedIconTypes,
      iFeaturedIconSizes,
      palette,
    };
  },
  computed: {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.verification-details {
  .title .icon {
    min-width: 36px;
  }

  .verification {
    border: 1px solid $light-neutral-60;
  }
}
</style>
